import React from "react";
import { CheckIcon, SparklesIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { bonuses } from "../data/landing";
export function Bonuses() {
  return <section className="bg-white px-4 py-16 sm:py-20" aria-labelledby="bonuses" data-id="element-63" data-mp="aujyu7fl211w">
      <div className="mx-auto max-w-5xl" data-id="element-64" data-mp="ft4ppg8y38do">
        <SectionHeading tone="light" title={<span id="bonuses" data-id="element-66" data-mp="1tlq5bu795cz">
              <span className="text-before" data-id="element-67" data-mp="1wrjx4drwvf1">5 exclusive bonuses</span> included with your purchase
            </span>} intro="Get more practical resources to complement your Blueprint." data-id="element-65" data-mp="fs3ffdzr6px0" />

        <div className="space-y-16" data-id="element-68" data-mp="3t0omsist43ul">
          {bonuses.map(b => <article key={b.number} className="md:grid md:grid-cols-2 md:items-center md:gap-10" data-id="element-69" data-mp="3t0y99wen7svj">
              <div className="-mx-4 md:mx-0" data-id="element-70" data-mp="1mb1nvmgup1ei">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="w-full" loading="lazy" data-id="element-71" data-mp="1r9uz188o0gbi" />
              </div>

              <div className="mt-4 md:mt-0" data-id="element-72" data-mp="3id526zlj0r7m">
                <div className="flex flex-wrap items-center gap-3" data-id="element-73" data-mp="3dfd0xeyzrsqr">
                  <span className="rounded-lg bg-ink px-3 py-1.5 font-display text-lg font-extrabold uppercase text-gold" data-id="element-74" data-mp="3df3bptlrtpm4">
                    Bonus #{b.number}
                  </span>
                  <span className="text-[15px] font-semibold text-slate-500" data-id="element-75" data-mp="3n5oja6jfa4h6">
                    Reference value <span className="line-through" data-id="element-76" data-mp="2zgdgkjiii00e">${b.value}</span>
                  </span>
                  <span className="rounded-lg bg-after px-2.5 py-1 text-[13px] font-extrabold uppercase text-ink" data-id="element-77" data-mp="2uhso569i4kmi">Free today</span>
                </div>

                <h3 className="mt-3 font-display text-[32px] font-extrabold uppercase leading-[1.02] text-ink sm:text-4xl" data-id="element-78" data-mp="33h5pfbnh22w5">{b.title}</h3>
                <p className="mt-3 text-[17px] font-bold leading-snug text-ink" data-id="element-79" data-mp="nozzqtl08ea6">{b.lead}</p>
                <p className="mt-1.5 text-[15px] leading-relaxed text-slate-600" data-id="element-80" data-mp="irq0km7tco95">{b.body}</p>

                <p className="mt-5 text-[13px] font-bold uppercase tracking-wider text-ink" data-id="element-81" data-mp="3cjppd29wr0po">You'll receive</p>
                <ul className="mt-2.5 space-y-2" data-id="element-82" data-mp="3hgyanbqcrkv5">
                  {b.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-slate-700" data-id="element-83" data-mp="3ljcp7jmznygm">
                      <span className="mt-0.5 flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-after" data-id="element-84" data-mp="3qhmnw47x9h6z">
                        <CheckIcon className="h-3 w-3 text-ink" strokeWidth={3.5} aria-hidden="true" data-id="element-85" data-mp="2tu9mi8ar2w63" />
                      </span>
                      <span data-id="element-86" data-mp="32t3h5t4itch0">{item}</span>
                    </li>)}
                </ul>

                <div className="mt-5 flex gap-3 rounded-2xl bg-slate-100 p-4" data-id="element-87" data-mp="37jjuld8ccy3d">
                  <SparklesIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#0891B2]" aria-hidden="true" data-id="element-88" data-mp="37lo90p3v9fhw" />
                  <p className="text-[15px] leading-relaxed text-slate-700" data-id="element-89" data-mp="2a2lc4mk8l10y">
                    <span className="font-bold text-ink" data-id="element-90" data-mp="2f1pkjazc6uq8">Why it's valuable: </span>
                    {b.why}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-14 rounded-3xl bg-ink px-4 py-10" data-id="element-91" data-mp="22j3p2z7s9szn">
          <CtaButton label="Yes! I want all 5 bonuses" caption="All 5 bonuses included free with the Blueprint™" data-id="element-92" data-mp="1xk8yhb3kr04z" />
        </div>
      </div>
    </section>;
}